import { POSITION } from "vue-toastification";

export const TOAST_CONFIGS = {
  FATAL_ERROR: {
    timeout: false,
    closeButton: false,
    position: POSITION.TOP_CENTER,
  },
  INVALID_REQUEST_ERROR: {
    timeout: 3000,
    position: POSITION.BOTTOM_CENTER,
  },
};
